/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React, {useEffect}from 'react';
import './Pagination.scss';

const paginate = (currentPage, lastPage, onPageChange, id) => {
  const delta = 2;
  const range = [];

  for (let i = Math.max(2, (currentPage - delta)); i <= Math.min((lastPage - 1), (currentPage + delta)); i += 1) {
    range.push(i);
  }

  if ((currentPage - delta) > 2) {
    range.unshift('...');
  }

  if ((currentPage + delta) < (lastPage - 1)) {
    range.push('...');
  }

  range.unshift(1);
  if (lastPage !== 1) {
    range.push(lastPage);
  }

  // useEffect(() => {
  //   console.log('pagination---', {currentPage})
  //   // Update the document title using the browser API
  //   //const v = document.getElementById(`page-${currentPage}`);
  //   //v.focus();
  // });

  return range.map((el, index) => (
    <li key={`li${index}`}>
      <button
        key={index}
        type='button'
        id={id?`${id}-page-${el}`:`page-${el}`}
        className={`cb-btn cb-btn-square cb-btn-greyscale ${currentPage === el ? 'cb-active' : ''}`}
        aria-current={`${currentPage === el ? 'true' : 'false'}`}
        onClick={(el!=='...'? () => onPageChange(el):() => (el))}>
        <span className='sr-only'>page</span>{el}
      </button>
    </li>
  ));
};

const Pagination = ({currentPage, lastPage, onPageChange, id}) => (

  <nav style={{width: "100%"}} aria-label={id?`${id} pagination`:`pagination`} className='pagiNav'>
    <ul className='cb-pagination' data-cb-apricot='pagination'>
      <li>
        <button className='cb-btn cb-btn-square cb-btn-greyscale' aria-label='Previous' onClick={() => onPageChange('pre')}>
          <span className='sr-only'>Go to previous page</span>
          <span aria-hidden='true' className='cb-icon cb-left' />
        </button>
      </li>

      {paginate(currentPage, lastPage, onPageChange, id)}

      <li>
        <button className='cb-btn cb-btn-square cb-btn-greyscale' aria-label='Next' onClick={() => onPageChange('next')}>
          <span className='sr-only'>Go to Next page</span>
          <span aria-hidden='true' className='cb-icon cb-right' />
        </button>
      </li>
    </ul>
  </nav>);

export default Pagination;